import {Core} from "@strapi/strapi";

export default ({ strapi }: { strapi: Core.Strapi }) => ({
  getButtons: async (ctx, next) => {
    const {apiID} = ctx.request.query;
    ctx.body = await strapi.plugin('telegram-bot').service('telegramAction').getButtons(apiID);
  },

  trigger: async (ctx, next) => {
    const {buttonID, id} = ctx.request.body;
    ctx.body = await strapi.plugin('telegram-bot').service('telegramAction').trigger(buttonID, id);
  }
});
